<template>
    <div>
      <el-dialog
        title="传感器下的测点"
        width="30%"
        v-model="SensorPointsContent.flag"
      >
      <el-table
        :data="SensorPointsContent.points"
        style="width: 100%">
        <el-table-column
          prop="pointUuid"
          label="测点Uuid">
        </el-table-column>
        <el-table-column
          prop="pointName"
          label="测点名">
        </el-table-column>
      </el-table>
        
        <template #footer>
        <span class="dialog-footer">

        </span>
        </template>
  </el-dialog>
    </div>
    
  </template>

<script>
import {ref, onBeforeMount ,onBeforeUnmount, onMounted,computed, watch,router,nextTick} from 'vue'
import mydark from "../../../static/halloween";
import * as echarts from "echarts";
export default {
  name: 'SensorPoints',
  props:['SensorPointsContent'],
  setup(props, ctx) {
    let show=ref(true)
    let timestampToTime=((timestamp)=>{
      var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + '-';
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
      var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
      var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
      var s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()) + '.';
      var ms = (timestamp % 1000).toString();
      while (ms.length < 3) {
        ms = '0' + ms;
      }
      //var nowtime = new Date(Y+M+D+h+m+s);
      return Y + M + D + h + m + s + ms;
    })
    onMounted(()=>{
        console.log('数据',props.SensorPointsContent);
    })
    onBeforeUnmount(()=>{
        // console.log('节点',TmyChart);
    })
    return {
      show
    }
  },
}
</script>
<style lang="scss">
    // margin-left: 10px;
    // margin-right: 10px;
    // background-color: #2c3242;
    // height: 75%;
    //去除表格最下面那条线
    .el-table::before{
      height: 0px;
    }
    .el-table{
      background-color: #2c3242;
      //去除表头下面那条线
      th.el-table__cell.is-leaf{
        border-bottom: 0px;
        background-color: #2c3242;
      }
      //设置排序图标的颜色
      // .descending .sort-caret.descending {
      //   border-top-color: #359186;
      // }
      // .ascending .sort-caret.ascending {
      //   border-bottom-color: #359186;
      // }
      .cell{
        text-align: center;
      }
      th{
        background-color: #2c3242;
        color: #fff;
        // border-right: 1px solid rgba(256, 256, 256, 0.5);
      }
      tr{
        background-color: #2c3242;
        color: #fff;
        td{
          border-bottom: 0px;
          background-color: #2c3242;
        }
      }
      tr:hover td{
        background-color: rgba(107, 199, 255, 0.98) !important;
      }
    }

</style>

